import React, { useEffect, useState } from 'react'
import styles from './LiveScore.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { homeData } from '../../features/home/homeSlice';

const LiveScore = ({match_id,team,val}) => {
  const [localItems, setLocalItems] = useState([]);
  const dispatch = useDispatch();
  const dataHome = useSelector((state) => state.home.data);
  const pendingHome = useSelector((state) => state.home.pending);
  const errorHome = useSelector((state) => state.home.error);
  const finalDataHome = dataHome?.data;
  console.log(localItems)

  // useEffect(() => {
  //   // if (finalDataHome) {
  //   //   let match = finalDataHome.find((item) => {
  //   //     return item.match_id === match_id;
  //   //   });
  //   // }
  //   // dispatch(homeData());
  // }, [dispatch]);

  // useEffect(() => {
  //   const intervalId = setInterval(()=>{

  //         dispatch(homeData());
  //         setLocalItems(finalDataHome)
  //       },1000)
       
  //     return ()=> clearInterval(intervalId)
  //   // fun()

  //   // dispatch(homeData())
    
    
    
  // }, [dispatch]);

  let teamName = {
    team_A : 'team_a_scores_over',
    team_B : 'team_b_scores_over'
  }
  return (
    
      <div >



        
      
      {
         finalDataHome
           ?.filter((item) => item.match_id === match_id)
           ?.map((item, index) => (

         
             item.match_status === 'Upcoming' ? <div></div>:<div>
               <p>
             {item?.[teamName[team]]?.length === 0
              ? "-"
              : item?.[teamName[team]]?.[0]?.score}
          </p>
          <p
                         
          >
            {item?.[teamName[team]]?.length === 0
              ? "yet to bat"
              : item?.[teamName[team]]?.[0]?.over + " over"}
          </p>
             </div>
             

           ))
}
   </div>
    
  
  )
}

export default LiveScore
